import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWealth } from '../../../../api';
import { useWealthContext } from '../../../../contexts/wealth-context';
import { useBalanceSheetTableColDefs } from '../../../../hooks/useBalanceSheetTableColDefs';
import type { IModalBalanceEntry } from '../../../../interfaces/balance-sheet-table';
import { BalanceSheetCategoryTitle } from '../BalanceSheetCategoryTitle';
import { BalanceSheetTable } from '../BalanceSheetTable';

interface IProps {
    handleShowModal: (modalEntry: IModalBalanceEntry) => void;
}

export const ExpenseTable: FunctionComponent<IProps> = ({ handleShowModal }) => {
    const { t } = useTranslation();
    const { clientCurrency } = useWealthContext();
    const { expenses, expensesTotal } = useWealth();
    const [showAll, setShowAll] = useState(false);

    const expenseColDefs = useBalanceSheetTableColDefs('incomeAndExpenses', clientCurrency ?? '', showAll);

    return (
        <div className="balance-sheet-table__container">
            <BalanceSheetCategoryTitle
                title={t('wealthExpensesSectionTitle')}
                totalText={t('wealthExpensesSectionTotal')}
                currency={clientCurrency}
                totalAmountCurrentYear={expensesTotal}
                showAll={showAll}
                onShowAllClick={setShowAll}
            />
            <BalanceSheetTable
                balanceSheetData={expenses}
                tableColDefs={expenseColDefs}
                showAll={showAll}
                enableCurrentYearFilter={true}
                onRowActionClick={handleShowModal}
            />
        </div>
    );
};
